import React from "react"
import DateTime from "react-datetime"
import CalendarContainer from "react-datetime/src/CalendarContainer"
import TetherComponent from "react-tether"

// Edit of <DateTime /> component from react-datetime
// to work with react-tether. By default the <DateTime /> component
// does not render the overlay/popup calendar in the correct position when used.

export default class TetheredDateTime extends DateTime {
    render() {
        let className = "rdt"

        if (this.props.className) {
            if (Array.isArray(this.props.className)) {
                className += " " + this.props.className.join(" ")
            } else {
                className += " " + this.props.className
            }
        }

        let children = []

        if (this.props.input) {
            const props = {
                key: "i",
                type: "text",
                className: "form-control",
                // @ts-expect-error
                onFocus: this.openCalendar,
                // @ts-expect-error
                onChange: this.onInputChange,
                // @ts-expect-error
                onKeyDown: this.onInputKey,
                value: this.state.inputValue,
                ...this.props.inputProps,
            }

            // @ts-expect-error
            if (!this.props.renderInput) {
                // @ts-expect-error
                children = <input {...props} />
            } else {
                // @ts-expect-error
                children = this.props.renderInput()
            }
        } else {
            className += " rdtStatic"
        }

        return (
            <div className={className}>
                <TetherComponent
                    // @ts-expect-error
                    attachment="top left"
                    targetAttachment="bottom left">
                    {children}
                    {this.state.open && (
                        // @ts-expect-error
                        <div className="rdtPicker" ref={this.props.pickerRef}>
                            <CalendarContainer
                                // @ts-expect-error
                                view={this.state.currentView}
                                onChange={this.props.onChange}
                                // @ts-expect-error
                                viewProps={this.getComponentProps()}
                            />
                        </div>
                    )}
                </TetherComponent>
            </div>
        )
    }
}
